import {ChangeDetectionStrategy, Component, HostBinding, Input, OnInit} from '@angular/core';
import {BucketType, Group} from '@paperlessio/sdk/api/models';
import {BlocksComponent} from '../blocks.component';

@Component({
  selector: 'app-group',
  templateUrl: '../blocks.component.html',
  styleUrls: [
    '../blocks.component.scss',
    './group.component.scss'
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class GroupComponent extends BlocksComponent implements OnInit {
  @Input() block: Group;

  public domId = '';
  public BucketType = BucketType;

  ngOnInit() {
    super.ngOnInit();

    if (this.blocksConfig.submittable) {
      this.domId = 'r' + (this.blocksConfig.editable ? 'e' : '') + (this.block.settings.editable ? 'q' : '');
    }
  }

  @HostBinding('class.padding') get padding(): boolean {
    return this.block.styles.full_width;
  }
  @HostBinding('style.padding-top.px') get paddingTop(): string {
    return this.block.styles?.padding.top;
  }
  @HostBinding('style.padding-right.px') get paddingRight(): string {
    return this.block.styles?.padding.right;
  }
  @HostBinding('style.padding-bottom.px') get paddingBottom(): string {
    return this.block.styles?.padding.bottom;
  }
  @HostBinding('style.padding-left.px') get paddingLeft(): string {
    return this.block.styles?.padding.left;
  }
  @HostBinding('style.background-color') get background(): string {
    return this.block.styles.background;
  }
  @HostBinding('style.border-radius.px') get borderRadius(): number {
    return this.block.styles?.border_radius;
  }
  @HostBinding('style.border-color') get borderColor(): string {
    return this.block.styles?.border?.color;
  }
  @HostBinding('style.border-width.px') get borderWidth(): number {
    return this.block.styles.border?.width;
  }
  @HostBinding('style.border-style') get borderStyle(): string {
    return this.block.styles.border?.active ? 'solid' : null;
  }
}
